import { render } from "./BtnGroup.vue?vue&type=template&id=7e349a88&scoped=true"
import script from "./BtnGroup.vue?vue&type=script&lang=js"
export * from "./BtnGroup.vue?vue&type=script&lang=js"

import "./BtnGroup.vue?vue&type=style&index=0&id=7e349a88&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e349a88"]])

export default __exports__